module.exports = __webpack_public_path__ + "img/bis_yes.5800fc89.png";